// app/javascript/projects/components/TeamModalAdd.jsx

import React, { useState } from 'react';
import { Button } from 'ui'
import {FormControl, FormGroup} from 'ui'
import { useSubscription } from '../../hooks/subscriptions/queries';
import { getSubscriptionAmount, getSubscriptionInterval } from '../../utils/subscriptionUtils';

function TeamModalAdd({ navigateToPage, PAGES, setPageData }) {
  const [email, setEmail] = useState("");
  const { data: subscription } = useSubscription();

  const handleSubmit = (e) => {
    e.preventDefault();
    // Store email in page data and navigate to payment page
    setPageData({ email });
    navigateToPage(PAGES.PAYMENT);
  };

  const onEmailChange = (e) => {
    setEmail(e.target.value);
  };

  return (
    <div style={{textAlign:"center"}}>
      <h4>Add Team Member to Delve</h4>
      <p>Add a team member for an additional ${getSubscriptionAmount(subscription)} per {getSubscriptionInterval(subscription)} per member</p>

      <div style={{marginTop:40, marginBottom:30}}>
        <form onSubmit={handleSubmit} style={{height:"100%"}}>
          <FormGroup controlId="formtranscriptName">
            <FormControl
              type="email"
              label="Email address"
              placeholder="Enter Address"
              value={email}
              onChange={onEmailChange}
            />
          </FormGroup>
          <Button variant="white" type="submit">
            Add Team Member
          </Button>
        </form>
      </div>
    </div>
  );
}

export default TeamModalAdd;